export const classeDivPrincipal = condicao => {
  return `${
    condicao ? 'px-[52px] py-6 bg-fundo bg-opacity-90 border border-fundo-borda' : 'px-5'
  } rounded-2xl flex-col justify-start items-start gap-8 inline-flex divide-y divide-fundo-borda`;
};

export const classeFundoBorda = condicao => {
  return `${
    condicao && 'divide-y divide-fundo-borda'
  } w-full flex-col justify-start items-start gap-8 inline-flex`;
};

export const classeAgruparCards = condicao => {
  return `${
    condicao ? 'grid-cols-1 divide-y divide-fundo-borda' : 'grid-cols-2'
  } grid gap-x-[3.25em] gap-y-8`;
};